import { useState, useEffect } from 'react';
import Uppy from '@uppy/core';
import { Dashboard } from '@uppy/react';
import Italian from '@uppy/locales/lib/it_IT';
import uploadIcon from '../../../../assets/redesign_icons/upload-icon.svg';
import { UppyContainer, UppyContainerV2 } from './UploaderBonifico.styles';

function UploaderBonifico(props) {
  const {
    note, allowedFileTypes, onFileUpload, v2,
  } = props;

  const [uppy, setUppy] = useState();

  useEffect(() => {
    const uploadConfigurationFileUpload = {
      locale: Italian,
      restrictions: {
        maxFileSize: 3000000,
        maxNumberOfFiles: 1,
        minNumberOfFiles: 1,
        allowedFileTypes: allowedFileTypes !== undefined ? allowedFileTypes : ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'],
      },
    };

    const uppy = new Uppy(uploadConfigurationFileUpload);

    uppy.on('file-added', (file) => {
      onFileUpload(file.data);
    });

    setUppy(uppy);
  }, []);

  if (uppy === undefined) {
    return <></>;
  }

  const Container = v2 ? UppyContainerV2 : UppyContainer;

  return (
    <Container icon={uploadIcon}>
      <Dashboard uppy={uppy} note={note} proudlyDisplayPoweredByUppy={false} />
    </Container>
  );
}

export default UploaderBonifico;
